import { watch } from "vue";
import { Control, DomEvent, DomUtil } from "leaflet";

import { closeDialog } from "~/client/components/modal/modal";
import { loading } from "~/client/elements/repository";
import { currentLocation } from "~/client/elements";

export const CancelButton = Control.extend({
	options: {
		position: "topright"
	},
	onAdd: function () {
		const container = DomUtil.create("div", "leaflet-custom-bar");
		const cancel = DomUtil.create("div", "leaflet-custom-button --close", container);
		cancel.innerHTML =
			'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

		DomEvent.on(cancel, "click", (event: Event) => {
			event.preventDefault();
			closeDialog();
		});

		return container;
	}
});

export const LoadingState = Control.extend({
	options: {
		position: "bottomright"
	},
	loaderElement: null as HTMLElement | null,
	onAdd: function () {
		const container = DomUtil.create("div", "leaflet-custom-bar");
		this.loaderElement = DomUtil.create("div", "__loader", container);

		this.updateLoaderVisibility();

		watch(loading, () => this.updateLoaderVisibility(), { deep: true });

		return container;
	},
	updateLoaderVisibility() {
		if (loading.value) {
			this.loaderElement!.style.display = "block";
		} else {
			this.loaderElement!.style.display = "none";
		}
	}
});

export const ConfirmButton = Control.extend({
	options: {
		position: "bottomright"
	},
	selectElement: null as HTMLElement | null,
	onAdd: function () {
		const container = DomUtil.create("div", "leaflet-custom-bar");
		this.selectElement = DomUtil.create("div", "leaflet-custom-button --confirm", container);
		this.selectElement.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="14" fill="#fff">
            <path d="M112 0C85.5 0 64 21.5 64 48l0 48L16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 208 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 160l-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l16 0 176 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 224l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 144 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 288l0 128c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L112 0zM544 237.3l0 18.7-128 0 0-96 50.7 0L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z" />
        </svg>
        Selecteren
      `;
		DomEvent.on(this.selectElement, "click", (event: Event) => {
			event.preventDefault();
			closeDialog();
		});

		this.updateLoaderVisibility();

		watch(currentLocation, this.updateLoaderVisibility, { deep: true });

		return container;
	},
	updateLoaderVisibility() {
		if (window.innerWidth > 768) return;

		if (currentLocation.value) {
			this.selectElement!.style.display = "block";
		} else {
			this.selectElement!.style.display = "none";
		}
	}
});
